/*
 * @Author: your name
 * @Date: 2022-04-07 16:37:57
 * @LastEditTime: 2022-11-23 14:36:41
 * @LastEditors: fyh 18107114013@sina.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /Luckytu-sign-h5/src/vant.ts
 */
import { 
    Picker,
    Popup,
    Button,
    Step,
    Steps,
    Field,
    CellGroup,
    Tab,
    Tabs,
    Dialog,
    Toast,
    Form,
    NumberKeyboard,
    Empty,
    Overlay,
    Loading
} from 'vant'
Toast.setDefaultOptions({position:'middle'})
const vantElements = [
    Picker,
    Popup,
    Button,
    Step,
    Steps,
    Field,
    CellGroup,
    Tab,
    Tabs,
    Dialog,
    Toast,
    Form,
    NumberKeyboard,
    Empty,
    Overlay,
    Loading
]
const vantUse = (app:any) => {
    return vantElements.forEach((item) => {
        app.use(item)
    },app)
}

export default vantUse